import type { NODE_TYPE_KEY } from '../newComponents/nodes'

export interface NODE_TYPE {
  value: NODE_TYPE_KEY
  name: string
  caption: string
}

export const NODES: NODE_TYPE[] = [
  // { value: 'input', name: '输入', caption: '执行起点，用户触发任务后首先执行该节点' },
  // { value: 'output', name: '输出', caption: '执行终点，触发后停止执行该任务' },
  {
    value: 'LLMAction',
    name: '提示词',
    caption: '调用已保存的提示词，大模型将根据提示词生成内容',
  },
  {
    value: 'JavaPluginAction',
    name: '自定义操作',
    caption: '支持业务应用实现的自定义操作，如后端业务逻辑执行或前端界面更新',
  },
  {
    value: 'MessageAction',
    name: '消息',
    caption: '回复指定内容，用于引导、提示用户',
  },
]

export interface RuleErrorItem {
  code: number
  msg: string
}

export const RULE_ERROR_CODE: {
  [key: string]: RuleErrorItem
} = {
  SAME_NAME: {
    code: 0,
    msg: '节点名称不可重复。',
  }, // 重名
  RING: {
    code: 1,
    msg: '节点不可形成环路。',
  }, // 环结构
  NOT_LINK_OUTPUT: {
    code: 2,
    msg: '节点连线不完整。',
  }, // 终点未连接到output节点
  DISCRETE: {
    code: 3,
    msg: '不允许存在离散节点。',
  }, // 存在离散节点
  UNCLOSE: {
    code: 4,
    msg: '节点连线不完整',
  }, // 存在未双端闭合节点(包含2)
  OTHER: {
    code: 5,
    msg: 'other error',
  },
}

export const TYPEIDS: {
  [key: string]: string
} = {
  LLMAction: '2',
  JavaPluginAction: '4',
  MessageAction: '5',
  Condition: '6',
  output: '1',
  input: '0',
}

export const BASIC_NODE_CONFIG_SIZE = {
  width: 200,
  height: 50,
}

export const BASIC_NODE_CONFIG = {
  ...BASIC_NODE_CONFIG_SIZE,
  zIndex: -100,
}

export const BASIC_LAYOUT_CONFIG = {
  AXIS: {
    x: 0,
    y: 0,
  },
  groupOffset: 25,
  HorizontalSpacing: 250,
  VerticalSpacing: 100,
}
